<div class="section-header">
    <div class="title">
        <span>
            Services
        </span>

        <app-info-icon-button [model]="{ title: 'Information',
                              messages: ['Wir bieten Ihnen für die Hardware u.a. folgende Möglichkeiten: Konfiguration, Aktivierung von Upgrades, Aktivierung der BSI Schnittstelle, Deaktivierung von Gerätefunktionen.'],
                              dialogHeight: 100}">
        </app-info-icon-button>

    </div>


    <div class="button-container" *ngIf="!isViewerMode">
        <div class="no-hardware-btn" (click)="onRemoveServicesFromOrderBtnLicked()"
             [ngClass]="{'invalid':(forceFormValidationVisibility || model.isStep4ButtonsValidationVisibilityForced) && !model.project?.requestedProductInfo?.requestedServiceComment} ">
            Nichts hinzufügen
        </div>

        <button (click)="onAddServiceBtnClicked()" class="btn-add-device" type="button"
                *ngIf="isAddServiceBtnVisible()"
                [ngClass]="{'invalid' : (forceFormValidationVisibility || model.isStep4ButtonsValidationVisibilityForced) && !projectRowItemsAmountComplyRules()}">
            <bd-fa-button [name]="'plus'">
            </bd-fa-button>
            <span>Service mitbuchen</span>
        </button>

        <div class="btn-add-device info-only" *ngIf="!isAddServiceBtnVisible()">
            <bd-fa-button [name]="'check'">
            </bd-fa-button>
            <span>Service mitbuchen</span>
        </div>

    </div>

</div>

<!--<div>this.model.isServiceOrderRequested {{this.model.isServiceOrderRequested}}</div>-->
<!--<div>this.isServiceDescriptionActive() {{this.isServiceDescriptionActive()}}</div>-->

<div class="body" *ngIf="isServiceDescriptionActive()">
    <bd-labeled-textarea [label]="'Kommentar' + (isViewerMode ?'': '*')"
                         placeholder="Bitte geben Sie hier an, welcher zusätzliche Service für das ausgewählte Modell benötigt wird. Unser technisches Team wird Sie zur Abstimmung kontaktieren."
                         [ngClass]="{'notify-change' : notifyChange( ProjectUpdateNotificationFieldEnum.PRODUCTS)}"
                         [maxlength]="'500'"
                         rows="4"
                         [forceFormValidationVisibility]="forceFormValidationVisibility"
                         name="requestedServiceComment"
                         [(ngModel)]="model.project.requestedProductInfo.requestedServiceComment"
                         limitTo="500"
                         required
                         [disabled]="isViewerMode">
    </bd-labeled-textarea>
</div>

